<script>
  export let id

  import { apikey, store } from "../store"
  import { PlanFromCMSPlan } from "../../cms/objects"
  import Common from "./Common.svelte"

  $: plan_promise = fetch(
    `https://marketplace.api.healthcare.gov/api/v1/plans/${id}?apikey=${apikey}`
  )
    .then((v) => v.json())
    .then(({ plan, ...d }) =>
      plan ? PlanFromCMSPlan(plan) : Promise.reject(d)
    )
    
</script>

<Common show_prices={false} {plan_promise} />
